import { E_ROUTE_MAILMANAGEMENT, E_ROUTE_NOTICE_CENTER, E_ROUTE_TROUBLESHOOTING } from './route.types';
const troubleshootingBreadcrumb = [
    {
        text: 'backoffice.nav.informationManagement',
    }
];
export default [
    // 消息管理
    {
        name: E_ROUTE_NOTICE_CENTER.NOTICE_DETAIL,
        path: '/troubleshooting/notice-center/notification-detail',
        component: () => import(/* webpackChunkName: "NotificationDetail" */ '../../views/troubleshooting/NoticeCenter/NotificationDetail/NotificationDetail.vue'),
        props: true,
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.notifications',
                },
                {
                    text: 'backoffice.nav.notificationDetail',
                    active: true,
                }
            ],
            permission: 'PostNotificationUserMessageList',
        },
    },
    {
        name: E_ROUTE_NOTICE_CENTER.NOTICE_CONFIGURATION,
        path: '/troubleshooting/notice-center/configuration',
        component: () => import(/* webpackChunkName: "NoticeConfiguration" */ '../../views/troubleshooting/NoticeCenter/NoticeConfiguration/NoticeConfiguration.vue'),
        props: true,
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.notifications',
                },
                {
                    text: 'backoffice.nav.notificationConfiguration',
                    active: true,
                }
            ],
            permission: 'PostNotificationScenesList',
        },
    },
    // add mail manage:
    {
        name: E_ROUTE_TROUBLESHOOTING.TROUBLESHOOTING_MAIL,
        path: '/troubleshooting/mail',
        component: () => import(/* webpackChunkName: "trouble_shooting" */ '../../views/troubleshooting/Mail/Mail.vue'),
        redirect: {
            name: E_ROUTE_MAILMANAGEMENT.SEND,
        },
        children: [
            {
                name: E_ROUTE_MAILMANAGEMENT.SETTING,
                path: '/troubleshooting/mail/setting',
                component: () => import(/* webpackChunkName: "mail_setting" */ '../../views/troubleshooting/Mail/MailSetting/index.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.Mail',
                        },
                        {
                            text: 'backoffice.Mail.setting',
                            active: true,
                        }
                    ],
                    permission: 'MailConfigList',
                },
            },
            {
                name: E_ROUTE_MAILMANAGEMENT.SEND,
                path: '/troubleshooting/mail/send',
                component: () => import(/* webpackChunkName: "mail-send" */ '../../views/troubleshooting/Mail/MailSend/MailSend.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.Mail',
                        },
                        {
                            text: 'backoffice.Mail.send',
                            active: true,
                        }
                    ],
                    permission: 'MailSendList',
                },
            },
            {
                name: E_ROUTE_MAILMANAGEMENT.RECEIPT,
                path: '/troubleshooting/mail/receipt',
                component: () => import(/* webpackChunkName: "MailReceipt" */ '../../views/troubleshooting/Mail/MailReceipt/MailReceipt.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.Mail',
                        },
                        {
                            text: 'backoffice.Mail.receipt',
                            active: true,
                        }
                    ],
                    permission: 'MailRecepitList',
                },
            },
            {
                name: E_ROUTE_MAILMANAGEMENT.UNREACHABLE,
                path: '/troubleshooting/mail/unreachable',
                component: () => import(/* webpackChunkName: "MailUnreachable" */ '../../views/troubleshooting/Mail/MailUnreachable/MailUnreachable.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.Mail',
                        },
                        {
                            text: 'backoffice.Mail.unreachable',
                            active: true,
                        }
                    ],
                    permission: 'MailUnreachableGetList',
                },
            }
        ],
    },
    {
        name: E_ROUTE_TROUBLESHOOTING.TROUBLESHOOTING_KICKOUT,
        path: '/troubleshooting/kickout',
        component: () => import(/* webpackChunkName: "Kickout" */ '../../views/troubleshooting/Kickout/Kickout.vue'),
        meta: {
            breadcrumb: [
                ...troubleshootingBreadcrumb,
                {
                    text: 'backoffice.nav.Kickout',
                    active: true,
                }
            ],
            permission: 'SessionKickoutauditrecordsGetList',
        },
    },
    // add message send:
    {
        name: E_ROUTE_TROUBLESHOOTING.TROUBLESHOOTING_MESSAGESEND,
        path: '/troubleshooting/messagesend',
        component: () => import(/* webpackChunkName: "MessageSend" */ '../../views/troubleshooting/MessageSend/MessageSend.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.MessageSend',
                    active: true,
                }
            ],
            permission: 'MessageSend',
        },
    },
    // 会话管理
    {
        name: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER,
        path: '/session-manager',
        redirect: {
            name: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER_USER,
        },
        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/troubleshooting/SessionManagement/SessionManagement.vue'),
        children: [
            {
                name: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER_USER,
                path: 'user',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/troubleshooting/SessionManagement/User/User.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.SessionManagement',
                        },
                        {
                            text: 'coreUtility.account.user',
                            active: true,
                        }
                    ],
                    permission: 'AccountSessionGetList',
                },
            },
            {
                name: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER_COMPANY,
                path: 'company',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/troubleshooting/SessionManagement/Company/Company.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.SessionManagement',
                        },
                        {
                            text: 'coreUtility.account.company',
                            active: true,
                        }
                    ],
                    permission: 'CompanySessionGetList',
                },
            }
        ],
    }
];
/**
 * 故障排除-邮件 页面级子菜单
 * 注意这里的顺序需要和菜单顺序保持一致
 */
export const MailRoutePermissionTable = [
    { name: E_ROUTE_MAILMANAGEMENT.SETTING, permission: 'MailConfigList' },
    { name: E_ROUTE_MAILMANAGEMENT.SEND, permission: 'MailSendList' },
    { name: E_ROUTE_MAILMANAGEMENT.RECEIPT, permission: 'MailRecepitList' },
    { name: E_ROUTE_MAILMANAGEMENT.UNREACHABLE, permission: 'MailUnreachableGetList' },
    { name: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER_USER, permission: 'AccountSessionGetList' },
    { name: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER_COMPANY, permission: 'CompanySessionGetList' }
];
